import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'

import resizeIframeToFitContent from '@newswebsiteapp/shared/lib/resizeIframeToFitContent'

turbolinksLoadedObservable.subscribe(async () => {
  $('[data-iframe-autoresize-height]').on('load', function () {
    resizeIframeToFitContent(this)
  })
})
